// extracted by mini-css-extract-plugin
export default {"container":"ar-z","heading":"br-z","text":"cr-z","info":"dr-z","link":"er-z","fullMaxWidth":"fr-z"};